import React from 'react';
import {Routes, Route, Navigate } from 'react-router-dom';
import Bookings from './admin/Bookings';
import Events from './admin/Events.jsx';
import Guests from './admin/Guests';
import Members from './admin/Members';
import Dashboard from './admin/Dashboard';
import ClubManagement from './admin/ClubManagement';
import AdminTournaments from './admin/Tournaments';
import { Box } from '@mui/material';

const Admin = () => {
    return (
        <Box>
            <Routes>
                <Route path="" element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="members" element={<Members />} />
                <Route path="bookings" element={<Bookings />} />
                <Route path="guests" element={<Guests />} />
                <Route path="events" element={<Events />} />
                <Route path="tournaments" element={<Navigate to="/admin/dashboard" replace />} />
                <Route path="club" element={<ClubManagement />} />
                {/* Catch-all für unbekannte Admin-Seiten -> Dashboard */}
                <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
            </Routes>
        </Box>
    )
}
export default Admin;